<template>
  <div id="" class="mainDiv">
    <h3 class="p">课程评分</h3>
    <el-rate v-model="score"></el-rate>
    <el-form ref="form" :model="form" label-width="0px">
      <!-- <el-input
        type="textarea"
        autosize
        placeholder="请输入内容"
        v-model="form.textarea"
      >
      </el-input> -->
      <el-form-item label="">
        <div style="margin: 20px 0">
          <el-input
            type="textarea"
            v-model="form.comment"
            clearable
            :autosize="{ minRows: 6, maxRows: 8 }"
            placeholder="课程点评内容"
            οninput="if(value.length>100) value=value.slice(0,5)"
            maxlength="100"
            show-word-limit
          ></el-input>
        </div>
      </el-form-item>
    </el-form>
    <div class="comment-ul">
      <div v-for="(item, i) in commentList" :key="item.id">
        <div
          :class="
            commentSelect == i ? 'comment-li comment-li-select' : 'comment-li'
          "
          @click="changeComment(i)"
        >
          {{ item.typeName }}
        </div>
      </div>
      <!-- <div :class="commentSelect==2?'comment-li comment-li-select':'comment-li'" @click="changeComment(2)">讲课效果一般</div>
      <div :class="commentSelect==3?'comment-li comment-li-select':'comment-li'" @click="changeComment(3)">不熟悉讲课内容。准备不充分，效果差</div> -->
    </div>
    <div style="text-align: center; margin-top: 50px">
      <el-button
        type="primary"
        @click="onSubmit"
        style="margin: 0 20px; width: 120px"
        >确认并签退</el-button
      >
    </div>
  </div>
</template>

<script>
import * as api from "@/api/attendance/mobile";
export default {
  name: "GongzhonghaoSignout",
  data() {
    return {
      score: "5",
      commentSelect: 0,
      commentList: "",
      form: {
        comment: "",
        textarea: "",
      },
    };
  },
  methods: {
    getContentList() {
      let that = this;
      api.getContentList().then(function ({ data }) {
        that.commentList = data.data;
        that.form.comment = data.data[0].typeName;
      });
    },
    changeComment(data) {
      this.commentSelect = data;
      this.form.comment = this.commentList[data].typeName;
      // if(data==1){
      //   this.form.comment='备课充分，思路清晰'
      // }else if(data==2){
      //   this.form.comment='讲课效果一般'
      // }else if(data==3){
      //   this.form.comment='不熟悉讲课内容。准备不充分，效果差'
      // }
    },
    goBack() {
      window.history.go(-1);
    },
    onSubmit() {
      let that = this;
      // let reqdata={
      //   id:this.$route.query.uid,
      //   content:this.form.comment,
      //   star:this.score,
      // }
      // api.getSignOutRecord(reqdata).then(function({data}){
      //   if(data.data.status!='0'){
      //     let url='GongzhonghaoSignout'
      //     that.$router.push({ name: url , query:{obj: data.data}});
      //   }else{
      //     that.$message({message: data.msg,type: 'warning'});
      //   }
      // })
      if (this.form.comment == "") {
        that.$message({ message: "请输入点评内容", type: "warning" });
        return;
      }
      let reqdata = {
        uid: this.$route.query.uid,
        courseId: this.$route.query.courseId,
        openid: this.$route.query.openId,
        qrId: this.$route.query.qrId,
        content: this.form.comment,
        star: this.score,
        type: 2,
      };
      api.signOut(reqdata).then(function ({ data }) {
        if (data.status == "0") {
          let url = "GongzhonghaoSignout";
          that.$router.push({ name: url, query: { obj: data.info } });
        } else {
          that.$message({ message: data.result, type: "warning" });
        }
      });
    },
  },
  created() {
    this.getContentList();
  },
  computed: {
    getUId() {
      return localStorage.getItem("uid") || "36";
    },
  },
};
</script>

<style lang="scss" scoped>
.h,
.p {
  text-align: center;
}
/deep/.el-rate {
  text-align: center;
  margin-top: 10px;
  height: 50px;
  margin-bottom: 10px;
}
/deep/.el-rate__icon {
  font-size: 36px;
}
/deep/.el-button--primary {
  background-color: #8acbc5;
  border-color: #8acbc5;
}
.comment-li {
  color: #999999;
  border: 1px solid #999999;
  border-radius: 8px;
  margin-top: 10px;
  text-align: center;
  padding: 5px;
  font-size: 12px;
}
.comment-li-select {
  color: #40e4bf;
  border: 1px solid #40e4bf;
}
</style>
